import { Badge } from 'reactstrap';
import AdminListGroup, {
  DisplayItem,
} from '../../../components/admin/AdminListGroup';
import { LatePaymentPenalty } from '../models/contractModel';
import ContractUpdatePenaltiesModal from './ContractUpdatePenaltiesModal';

interface Props {
  id: string;
  paymentPenalty: LatePaymentPenalty[];
}

const ContractPaymentPenalty: React.FC<Props> = ({ id, paymentPenalty }) => {
  const itemList: DisplayItem[] = [];

  if (paymentPenalty.length > 0) {
    paymentPenalty.forEach((children) => {
      const badge = (
        <>
          <Badge
            className="badge-lg"
            color={children.is_active ? 'success' : 'danger'}
          >
            {children.is_active ? 'Activo' : 'Desactivado'}
          </Badge>
          <Badge className="badge-lg" color="info">
            {children.percentage_penalty} %{' '}
          </Badge>
        </>
      );
      itemList.push({
        title: `Penalidad del ${children.from_day_of_month} al ${children.to_day_of_month} de cada mes`,
        value: badge,
      });
    });
  }

  return (
    <AdminListGroup
      title={'Penalidades de pago'}
      items={itemList}
      footer={
        <ContractUpdatePenaltiesModal id={id} penalties={paymentPenalty} />
      }
    />
  );
};

export default ContractPaymentPenalty;
